<template>
  <VueSwing
    :ref="`card${id}`"
    :style="styleRandomRotationAndPosition"
    @throwoutleft="tagCardBad"
    @throwoutright="tagCardGood"
    @throwoutup="comment"
    @throwoutdown="tagCardConfused"
    :config="configCard"
  >
    <div class="card">
      <div v-if=" type === 'intent'" class="type type-compare intent">
        <div class="mark top">{{ $t('task.intent.t1') }}</div>
        <div class="mark bottom">{{ $t('task.intent.t2') }}</div>
        <div class="item a">{{content.question}}</div>
        <div class="item b">{{content.feat}}</div>
        <div class="domain">{{content.domain}}</div>
      </div>
      <div v-else-if=" type === 'attention' " class="type attention">
        <div class="phrase">
          <!-- TODO await for api update -->
          <!-- <span class="segment" v-for="(node, index) in content.segment" :key="index"> -->
          <span class="segment" v-for="(node, index) in content" :key="index">
            <span v-if="node.tag === 'slot'" class="dynamic">
              <div class="name">{{node.name}}</div>
              {{node.text}}
            </span>
            <span
              v-else
              v-for="(character, index) in node.text"
              :key="index"
              class="static"
            >{{character}}</span>
          </span>
        </div>
        <div class="domain">{{extra.domain}}</div>
      </div>
      <div v-else-if=" type === 'query_similarity' " class="type type-compare query_similarity">
        <div class="mark top">像</div>
        <div class="mark bottom">🐘</div>
        <div class="item a">{{content.a.query}}</div>
        <div class="item b">{{content.b.query}}</div>
        <div class="domain">{{content.domain}}</div>
      </div>
      <div v-else-if=" type === 'similarity' " class="type type-compare similarity">
        <div class="mark top">{{content.a.num_iid}}</div>
        <div class="mark bottom">{{content.b.num_iid}}</div>
        <div class="item a">
          <img class="pic" :src="content.a.pic">
          <div class="title">{{content.a.title}}</div>
        </div>
        <div class="item b">
          <img class="pic" :src="content.b.pic">
          <div class="title">{{content.b.title}}</div>
        </div>
        <div class="domain">{{content.domain}}</div>
      </div>
      <div v-else class="type">
        <a href="https://git.leyantech.com/support/binder-ng/issues/new">太前卫了，请提醒我支持下</a>
      </div>
    </div>
  </VueSwing>
</template>

<script>
import VueSwing from 'vue-swing'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    VueSwing
  },
  props: {
    info: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    isTop: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      // vue-swing config object
      configCard: {
        throwOutConfidence: (deltaX, deltaY) => {
          const confidence = Math.sqrt(deltaX * deltaX + deltaY * deltaY) / 150 >= 1 ? 1 : 0
          return confidence
        },
        throwOutDistance: () => 700,
        allowedDirections: [
          VueSwing.Direction.DOWN,
          VueSwing.Direction.LEFT,
          VueSwing.Direction.RIGHT,
          VueSwing.Direction.UP
        ]
      },
      rotationOffset: (Math.random() * (1 - -1) - 1) * 5,
      positionOffsetY: (Math.random() * (1 - -1) - 1) * 10,
      positionOffsetX: (Math.random() * (1 - -1) - 1) * 10,
      throwDuration: 300
    }
  },
  computed: {
    ...mapState([
      'throwState',
      'isResetingCard'
    ]),
    styleRandomRotationAndPosition () {
      const [positionOffsetX, positionOffsetY] = [this.positionOffsetX, this.positionOffsetY]
      const style = this.isTop ? {
        transform: `rotate(0) translate(0,0)`,
        transition: `transform .1s ease`
      } : {
        transform: `rotate(${this.rotationOffset}deg) 
          translate(${positionOffsetX}px, ${positionOffsetY}px`
      }
      return style
    },
    id () {
      return this.info.id
    },
    score () {
      return this.info.score
    },
    status () {
      return this.info.status
    },
    content () {
      return this.info.content
    },
    extra () {
      return this.info.extra
    }
  },
  watch: {
    throwState (newState) {
      if (newState.isThrowing && newState.cardId === this.id) {
        this.swingCard(newState.direction)
      }
    },
    isResetingCard (newState) {
      if (newState) {
        this.swingCard()
      }
    }
  },
  methods: {
    ...mapMutations([
      'throwCard',
      'hasThrownCard',
      'doneResetCard'
    ]),
    ...mapActions([
      'cardIsGood',
      'cardIsBad',
      'cardIsConfused',
      'cardIsScored',
      'triggerIndicator'
    ]),
    swingCard (direction) {
      const card = this
      switch (direction) {
        case VueSwing.Direction.RIGHT:
        case VueSwing.Direction.LEFT:
        case VueSwing.Direction.UP:
        case VueSwing.Direction.DOWN:
          this.$refs[`card${this.id}`].cards[0].throwOut(0, 0, direction)
          setTimeout(() => {
            card.hasThrownCard()
          }, this.throwDuration)
          break
        // no direction which means throw back to center
        default:
          this.$refs[`card${this.id}`].cards[0].throwIn(0, 0)
          setTimeout(() => {
            card.doneResetCard()
          }, this.throwDuration)
      }
    },
    throwCardLeft () {
      this.swingCard(VueSwing.Direction.LEFT)
    },
    throwCardRight () {
      this.swingCard(VueSwing.Direction.RIGHT)
    },
    throwCardDown () {
      this.swingCard(VueSwing.Direction.DOWN)
    },
    putBackTopCard () {
      // this.
    },
    tagCardGood () {
      this.cardIsGood(this.id)
      this.triggerIndicator()
      this.throwCard({
        id: this.id,
        direction: VueSwing.Direction.RIGHT
      })
    },
    tagCardBad () {
      this.cardIsBad(this.id)
      this.triggerIndicator()
      this.throwCard({
        id: this.id,
        direction: VueSwing.Direction.LEFT
      })
    },
    tagCardConfused () {
      this.cardIsConfused(this.id)
      this.triggerIndicator()
      this.throwCard({
        id: this.id,
        direction: VueSwing.Direction.DOWN
      })
    },
    scoreCard (value) {
      this.cardIsScored({
        id: this.id,
        score: value
      })
    },
    comment () {
      this.$parent.$parent.openCommentDialog()
    },
    cancelComment () {
      this.$parent.$parent.closeCommentDialog()
    }
  },
  mounted () {
    // console.log(this.info)
  }
}
</script>

<style lang="scss" scoped>
@import "~@/stylesheets/color.scss";
@import "~@/stylesheets/layer.scss";
@import "~@/stylesheets/function.scss";

$card_width: 40vh;
.card {
  cursor: pointer;
  overflow: hidden;

  position: absolute;
  margin-left: $card_width * -0.5;
  margin-top: $card_width / 5 * 7 * -0.5;
  height: $card_width / 5 * 7;
  width: $card_width;
  border-radius: 1rem;
  box-shadow: 0rem 0rem 0.25rem rgba(0, 0, 0, 0.25);
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: 0rem 0rem 3rem rgba(0, 0, 0, 0.25);
  }

  .type {
    width: 100%;
    height: 100%;
    padding: 0;
    background: rgba($color_bleu_de_france, 1);
    .domain {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      color: white;
      font-size: 0.85rem;
      opacity: 0.7;
    }
    &-compare {
      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 28vh;
        width: 40vh;
        background: white;
        transform-origin: 50% 0%;
        transform: rotate(-5deg) scale(1.2);
      }
      .mark {
        position: absolute;
        font-size: 1.25rem;
        opacity: 0.5;
        &.top {
          top: 0.75rem;
          left: 0.5rem;
          color: white;
        }
        &.bottom {
          bottom: 0.75rem;
          right: 0.5rem;
          color: black;
        }
      }
      .item {
        font-size: 1.5rem;
        position: absolute;
        line-height: 1.25em;
        box-sizing: border-box;
        padding-left: 0.5em;
        padding-right: 0.5em;
        left: 50%;
        width: 100%;
        &.a {
          color: white;
          top: 32.5%;
          transform: translate(-50%, -50%);
        }
        &.b {
          color: $color_bleu_de_france;
          bottom: 32.5%;
          transform: translate(-50%, 50%);
        }
      }
      &.intent {
        .mark {
          &.bottom {
            opacity: 0.3;
          }
        }
      }
      &.query_similarity {
        .mark {
          &.bottom {
            bottom: -0.25rem;
          }
        }
      }
      &.similarity {
        .mark {
          font-size: 0.75rem;
        }
        .item {
          &.a {
            top: 30%;
          }
          &.b {
            bottom: 30%;
          }
          .pic {
            width: 35%;
          }
          .title {
            font-size: 0.95rem !important;
            width: 80%;
            margin: 0 auto;
            line-height: 1.2em !important;
          }
        }
      }
    }
    &.attention {
      background: white;
      .domain {
        color: black;
      }
      .phrase {
        font-size: 1.25rem;
        line-height: 1.25em;
        position: absolute;
        width: 90%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .segment {
          display: inline-block;
          line-height: 3rem;
          margin: 0 0.1rem;
          .static {
            display: inline-block;
          }
          .dynamic {
            // text-decoration: underline $color_bleu_de_france;
            border-bottom: solid 2px $color_bleu_de_france;
            .name {
              line-height: 1.65rem;
              width: 100%;
              box-sizing: border-box;
              float: bottom;
              background: $color_bleu_de_france;
              color: white;
              border-radius: rem(3);
              padding: 0 0.25rem;
              font-size: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>
